export type Callback = (...args: any[]) => void

export interface EventCallbacks {
  [event: string]: {
    [id: string]: Callback
  }
}

const eventCallbacks: EventCallbacks = {}

export function registerEventCallback(event: string, id: string, callback: Callback): void {
  if (!eventCallbacks[event]) eventCallbacks[event] = {}

  eventCallbacks[event][id] = callback
}

export function unregisterEventCallback(event: string, id: string): void {
  delete eventCallbacks[event]?.[id]
}

export function getEventCallbacks(event: string): { [id: string]: Callback } | undefined {
  return eventCallbacks[event]
}

export function emitEvent(event: string, ...args: any[]): void {
  const callbacks = getEventCallbacks(event)

  if (!callbacks) return

  for (const callback of Object.values(callbacks)) {
    try {
      callback(...args)
    } catch (error) {
      console.error(`[eventbus] callback for ${event} failed`, error)
    }
  }
}
